import React from 'react';
import {Route, Switch, Redirect} from 'react-router-dom';

import Collection from './components/Refunds';

import ErrorBoundaryRoute from '../../../../containers/ErrorBoundaryRoute';
import Object from "./components/Refund";

export default ({match, regions,roles}) => (

	<div>
		<Switch>
			<ErrorBoundaryRoute exact path={`${match.url}`}>
				<Collection regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>
		</Switch>

		<ErrorBoundaryRoute path={`${match.url}/:id`}>
			<Object regions={regions} baseUrl={match.url} roles={roles}/>
		</ErrorBoundaryRoute>
	</div>
);
